import React from "react";

// The built-in Button from "react-bootstrap" was not playing well with other elements
// so I've created the style "my-query-builder-button" to look like a bootstrap button
// but play well with other elements.
const BootstrapActionElement = ({ className, handleOnClick, label, title }) => (
  <button
    className={`my-query-builder-button ${className}`}
    title={title}
    onClick={(e) => handleOnClick(e)}
  >
    {label}
  </button>
);

BootstrapActionElement.displayName = "BootstrapActionElement";

export default BootstrapActionElement;
